<template>
  <v-app-bar absolute app style="width: auto;" flat>
    <v-btn
      fab
      small
      @click="
        $vuetify.breakpoint.smAndDown
          ? setDrawer(!drawer)
          : $emit('input', !value)
      "
    >
      <v-icon v-if="value">
        mdi-menu
      </v-icon>
      <v-icon v-else>
        mdi-backburger
      </v-icon>
    </v-btn>
    <v-toolbar-title style="font-size: 2rem">
      {{ $route.name }}
    </v-toolbar-title>
    <v-btn
      v-if="isImpersonate()"
      class="ml-6"
      color="red"
      @click="backToAdmin()"
    >
      管理者ユーザーに戻る
    </v-btn>
    <v-progress-circular
      v-if="processingUsers"
      :indeterminate="processingUsers"
      color="red"
    />
    <v-spacer />
    <p v-if="user" class="mt-3">{{ user.email }}</p>
    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn icon large v-bind="attrs" v-on="on">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <v-list :tile="false" flat nav>
        <template v-for="(p, i) in profile">
          <v-divider v-if="p.divider" :key="`divider-${i}`" class="mb-2 mt-2" />
          <v-list-item @click="signOut" v-bind:key="p.key">
            <v-list-item-title>{{ p.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppBar',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    drawer: true,
    profile: [
      {
        key: 'log-out',
        title: 'Log out'
      }
    ],
    processingUsers: false
  }),
  methods: {
    ...mapActions({
      setDrawer: 'interfaceControls/setDrawer',
      signOutAction: 'users/signOut',
      signInWithToken: 'users/signInWithToken',
      showSnack: 'snackbar/showSnack',
      clearToken: 'tokens/clearToken'
    }),
    async signOut() {
      if (!confirm('ログアウトしますか？')) {
        return
      }

      await this.signOutAction()
      this.$router.push('/')
    },
    isImpersonate() {
      return this.token !== null
    },
    async backToAdmin() {
      this.processingUsers = true

      try {
        // Sign in as a given user.
        const signInResult = await this.signInWithToken({
          token: this.token
        })

        if (signInResult.uid === this.user.uid) {
          this.clearToken()

          this.showSnack({
            message: '管理者ユーザーへの切り替えに成功しました'
          })
        } else {
          this.showSnack({
            message: '管理者ユーザーへの切り替えに失敗しました',
            color: 'error'
          })
        }
      } catch (error) {
        this.showSnack({
          message: '管理者ユーザーへの切り替えに失敗しました',
          color: 'error'
        })
      }

      this.processingUsers = false
    }
  },
  computed: {
    ...mapGetters({
      user: 'users/getActiveUser',
      token: 'tokens/getToken'
    })
  }
}
</script>
